import { assign } from 'lodash';
import { defineMessages } from 'react-intl';
import money, { format } from '../../lib/money';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  minContribution: {
    id: 'editPurchase.errors.minContribution',
    defaultMessage: 'Min contribution must be less than or equal to {amount}',
  },

  maxSlotsAboveCap: {
    id: 'editPurchase.errors.maxSlotsAboveCap',
    defaultMessage: 'Max {slotsName} must be less than or equal to {cap}',
  },
  maxSlotsAboveCap_adult: {
    id: 'editPurchase.errors.maxSlotsAboveCap_adult',
    defaultMessage: 'Max adults must be less than or equal to {cap}',
  },
  maxSlotsAboveCap_passenger: {
    id: 'editPurchase.errors.maxSlotsAboveCap_passenger',
    defaultMessage: 'Max passengers must be less than or equal to {cap}',
  },
  maxSlotsAboveCap_ticket: {
    id: 'editPurchase.errors.maxSlotsAboveCap_ticket',
    defaultMessage: 'Max tickets must be less than or equal to {cap}',
  },
  maxSlotsAboveCap_seat: {
    id: 'editPurchase.errors.maxSlotsAboveCap_seat',
    defaultMessage: 'Max seats must be less than or equal to {cap}',
  },
  maxSlotsAboveCap_item: {
    id: 'editPurchase.errors.maxSlotsAboveCap_item',
    defaultMessage: 'Max items must be less than or equal to {cap}',
  },
  maxSlotsAboveCap_shirt: {
    id: 'editPurchase.errors.maxSlotsAboveCap_shirt',
    defaultMessage: 'Max shirts must be less than or equal to {cap}',
  },
  maxSlotsAboveCap_person: {
    id: 'editPurchase.errors.maxSlotsAboveCap_person',
    defaultMessage: 'Max people must be less than or equal to {cap}',
  },
  maxSlotsAboveCap_guest: {
    id: 'editPurchase.errors.maxSlotsAboveCap_guest',
    defaultMessage: 'Max guests must be less than or equal to {cap}',
  },
  maxSlotsAboveCap_player: {
    id: 'editPurchase.errors.maxSlotsAboveCap_player',
    defaultMessage: 'Max players must be less than or equal to {cap}',
  },
  maxSlotsAboveCap_student: {
    id: 'editPurchase.errors.maxSlotsAboveCap_student',
    defaultMessage: 'Max students must be less than or equal to {cap}',
  },

  maxSlotsBelowMin: {
    id: 'editPurchase.errors.maxSlotsBelowMin',
    defaultMessage: 'Max {slotsName} must be greater than or equal to {minSlots}',
  },
  maxSlotsBelowMin_adult: {
    id: 'editPurchase.errors.maxSlotsBelowMin_adult',
    defaultMessage: 'Max adults must be greater than or equal to {minSlots}',
  },
  maxSlotsBelowMin_passenger: {
    id: 'editPurchase.errors.maxSlotsBelowMin_passenger',
    defaultMessage: 'Max passengers must be greater than or equal to {minSlots}',
  },
  maxSlotsBelowMin_ticket: {
    id: 'editPurchase.errors.maxSlotsBelowMin_ticket',
    defaultMessage: 'Max tickets must be greater than or equal to {minSlots}',
  },
  maxSlotsBelowMin_seat: {
    id: 'editPurchase.errors.maxSlotsBelowMin_seat',
    defaultMessage: 'Max seats must be greater than or equal to {minSlots}',
  },
  maxSlotsBelowMin_item: {
    id: 'editPurchase.errors.maxSlotsBelowMin_item',
    defaultMessage: 'Max items must be greater than or equal to {minSlots}',
  },
  maxSlotsBelowMin_shirt: {
    id: 'editPurchase.errors.maxSlotsBelowMin_shirt',
    defaultMessage: 'Max shirts must be greater than or equal to {minSlots}',
  },
  maxSlotsBelowMin_person: {
    id: 'editPurchase.errors.maxSlotsBelowMin_person',
    defaultMessage: 'Max people must be greater than or equal to {minSlots}',
  },
  maxSlotsBelowMin_guest: {
    id: 'editPurchase.errors.maxSlotsBelowMin_guest',
    defaultMessage: 'Max guests must be greater than or equal to {minSlots}',
  },
  maxSlotsBelowMin_player: {
    id: 'editPurchase.errors.maxSlotsBelowMin_player',
    defaultMessage: 'Max players must be greater than or equal to {minSlots}',
  },
  maxSlotsBelowMin_student: {
    id: 'editPurchase.errors.maxSlotsBelowMin_student',
    defaultMessage: 'Max students must be greater than or equal to {minSlots}',
  },

  minSlotsBelowMin: {
    id: 'editPurchase.errors.minSlotsBelowMin',
    defaultMessage: 'Min {slotsName} must be greater than or equal to {minSlots}',
  },
  minSlotsBelowMin_adult: {
    id: 'editPurchase.errors.minSlotsBelowMin_adult',
    defaultMessage: 'Min adults must be greater than or equal to {minSlots}',
  },
  minSlotsBelowMin_passenger: {
    id: 'editPurchase.errors.minSlotsBelowMin_passenger',
    defaultMessage: 'Min passengers must be greater than or equal to {minSlots}',
  },
  minSlotsBelowMin_ticket: {
    id: 'editPurchase.errors.minSlotsBelowMin_ticket',
    defaultMessage: 'Min tickets must be greater than or equal to {minSlots}',
  },
  minSlotsBelowMin_seat: {
    id: 'editPurchase.errors.minSlotsBelowMin_seat',
    defaultMessage: 'Min seats must be greater than or equal to {minSlots}',
  },
  minSlotsBelowMin_item: {
    id: 'editPurchase.errors.minSlotsBelowMin_item',
    defaultMessage: 'Min items must be greater than or equal to {minSlots}',
  },
  minSlotsBelowMin_shirt: {
    id: 'editPurchase.errors.minSlotsBelowMin_shirt',
    defaultMessage: 'Min shirts must be greater than or equal to {minSlots}',
  },
  minSlotsBelowMin_person: {
    id: 'editPurchase.errors.minSlotsBelowMin_person',
    defaultMessage: 'Min people must be greater than or equal to {minSlots}',
  },
  minSlotsBelowMinguest: {
    id: 'editPurchase.errors.minSlotsBelowMin_guest',
    defaultMessage: 'Min guests must be greater than or equal to {minSlots}',
  },
  minSlotsBelowMin_player: {
    id: 'editPurchase.errors.minSlotsBelowMin_player',
    defaultMessage: 'Min players must be greater than or equal to {minSlots}',
  },
  minSlotsBelowMin_student: {
    id: 'editPurchase.errors.minSlotsBelowMin_student',
    defaultMessage: 'Min students must be greater than or equal to {minSlots}',
  },

  minSlotsAboveCap: {
    id: 'editPurchase.errors.minSlotsAboveCap',
    defaultMessage: 'Min {slotsName} must be less than or equal to {cap}',
  },
  minSlotsAboveCap_adult: {
    id: 'editPurchase.errors.minSlotsAboveCap_adult',
    defaultMessage: 'Min adults must be less than or equal to {cap}',
  },
  minSlotsAboveCap_passenger: {
    id: 'editPurchase.errors.minSlotsAboveCap_passenger',
    defaultMessage: 'Min passengers must be less than or equal to {cap}',
  },
  minSlotsAboveCap_ticket: {
    id: 'editPurchase.errors.minSlotsAboveCap_ticket',
    defaultMessage: 'Min tickets must be less than or equal to {cap}',
  },
  minSlotsAboveCap_seat: {
    id: 'editPurchase.errors.minSlotsAboveCap_seat',
    defaultMessage: 'Min seats must be less than or equal to {cap}',
  },
  minSlotsAboveCap_item: {
    id: 'editPurchase.errors.minSlotsAboveCap_item',
    defaultMessage: 'Min items must be less than or equal to {cap}',
  },
  minSlotsAboveCap_shirt: {
    id: 'editPurchase.errors.minSlotsAboveCap_shirt',
    defaultMessage: 'Min shirts must be less than or equal to {cap}',
  },
  minSlotsAboveCap_person: {
    id: 'editPurchase.errors.minSlotsAboveCap_person',
    defaultMessage: 'Min people must be less than or equal to {cap}',
  },
  minSlotsAboveCap_guest: {
    id: 'editPurchase.errors.minSlotsAboveCap_guest',
    defaultMessage: 'Min guests must be less than or equal to {cap}',
  },
  minSlotsAboveCap_player: {
    id: 'editPurchase.errors.minSlotsAboveCap_player',
    defaultMessage: 'Min players must be less than or equal to {cap}',
  },
  minSlotsAboveCap_student: {
    id: 'editPurchase.errors.minSlotsAboveCap_student',
    defaultMessage: 'Min students must be less than or equal to {cap}',
  },

  minSlotsAboveMaxSlots: {
    id: 'editPurchase.errors.minSlotsAboveMaxSlots',
    defaultMessage: 'Min {slotsName} must be less than max {slotsName}',
  },
  minSlotsAboveMaxSlots_adult: {
    id: 'editPurchase.errors.minSlotsAboveMaxSlots_adult',
    defaultMessage: 'Min adults must be less than max adults',
  },
  minSlotsAboveMaxSlots_passenger: {
    id: 'editPurchase.errors.minSlotsAboveMaxSlots_passenger',
    defaultMessage: 'Min passengers must be less than max passengers',
  },
  minSlotsAboveMaxSlots_ticket: {
    id: 'editPurchase.errors.minSlotsAboveMaxSlots_ticket',
    defaultMessage: 'Min tickets must be less than max tickets',
  },
  minSlotsAboveMaxSlots_seat: {
    id: 'editPurchase.errors.minSlotsAboveMaxSlots_seat',
    defaultMessage: 'Min seats must be less than max seats',
  },
  minSlotsAboveMaxSlots_item: {
    id: 'editPurchase.errors.minSlotsAboveMaxSlots_item',
    defaultMessage: 'Min items must be less than max items',
  },
  minSlotsAboveMaxSlots_shirt: {
    id: 'editPurchase.errors.minSlotsAboveMaxSlots_shirt',
    defaultMessage: 'Min shirts must be less than max shirts',
  },
  minSlotsAboveMaxSlots_person: {
    id: 'editPurchase.errors.minSlotsAboveMaxSlots_person',
    defaultMessage: 'Min people must be less than max people',
  },
  minSlotsAboveMaxSlots_guest: {
    id: 'editPurchase.errors.minSlotsAboveMaxSlots_guest',
    defaultMessage: 'Min guests must be less than max guests',
  },
  minSlotsAboveMaxSlots_player: {
    id: 'editPurchase.errors.minSlotsAboveMaxSlots_player',
    defaultMessage: 'Min players must be less than max players',
  },
  minSlotsAboveMaxSlots_student: {
    id: 'editPurchase.errors.minSlotsAboveMaxSlots_student',
    defaultMessage: 'Min students must be less than max students',
  },
});

export default (values, props) => {
  const { purchase } = props;
  const errors = {};
  const formatter = formatMessage(props.intl);

  if (values.minContribution) {
    assign(errors, validateMinContribution(values, purchase, formatter));
  }
  if (values.minSlots) {
    assign(errors, validateMinSlots(values, purchase, formatter));
  }
  if (values.maxSlots) {
    assign(errors, validateMaxSlots(values, purchase, formatter));
  }

  return errors;
};

const validateMinContribution = (values, purchase, formatMessage) => {
  const totalCost = money(purchase.currentTotalCostAmount);
  const totalAmount = format(totalCost);

  if (money(values.minContribution).isGreaterThan(totalCost)) {
    return {
      minContribution: formatMessage(i18n.minContribution, { amount: totalAmount }, purchase.slotName),
    };
  }

  return {};
};

const validateMaxSlots = (values, purchase, formatMessage) => {
  const maxSlots = parseInt(values.maxSlots, 10);
  const minSlots = parseInt(values.minSlots, 10);
  const productMaxSlots = purchase.product.maxSlots;

  if (productMaxSlots && maxSlots > productMaxSlots) {
    return {
      maxSlots: formatMessage(i18n.maxSlotsAboveCap, { cap: productMaxSlots }, purchase.slotName),
    };
  }

  if (maxSlots < minSlots) {
    return {
      maxSlots: formatMessage(i18n.maxSlotsBelowMin, { minSlots }, purchase.slotName),
    };
  }

  return {};
};

const validateMinSlots = (values, purchase, formatMessage) => {
  const setMaxSlots = !!values.setMaxSlots;
  const maxSlots = parseInt(values.maxSlots, 10);
  const minSlots = parseInt(values.minSlots, 10);
  const productMinSlots = purchase.product.minSlots;
  const productMaxSlots = purchase.product.maxSlots;

  if (minSlots < productMinSlots) {
    return {
      minSlots: formatMessage(i18n.minSlotsBelowMin, { minSlots: productMinSlots }, purchase.slotName),
    };
  }

  if (productMaxSlots && minSlots > productMaxSlots) {
    return {
      minSlots: formatMessage(i18n.minSlotsAboveCap, { cap: productMaxSlots }, purchase.slotName),
    };
  }

  if (setMaxSlots && minSlots > maxSlots) {
    return {
      minSlots: formatMessage(i18n.minSlotsAboveMaxSlots, purchase.slotName),
    };
  }

  return {};
};



// WEBPACK FOOTER //
// ./src/desktop/components/edit-purchase/validate.js